module.exports = __webpack_public_path__ + "c2ef4382e5448bf4599fd3266a349db1.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_4_tri.mp3
 ** module id = 181
 ** module chunks = 0
 **/